/**
 * Признак того, что HH-поиск использует post-fetch фильтрацию (она же — пост-фильтр).
 *
 * Контракт с backend (relevanter-back/routes/hh.js):
 *   needsPostFilter = excludeJumpers || (filterByExpIndustry && resolvedExpIndustryIds.length > 0) || Boolean(positionNameForCurrent)
 *
 * Когда флаг включён, backend возвращает `hhCursor` — HH-страницу, на которой
 * остановился, чтобы фронт мог продолжить пагинацию с того же места. Если фронт
 * не учтёт какой-либо из источников пост-фильтра, маппинг `page → hhCursor`
 * не сохраняется и следующая страница начнёт фильтровать HH-выдачу с нуля
 * (дубликаты + неверный totalPages).
 *
 * TASKNEIROKLYUCH-812: добавлен `currentPositionOnly` — фильтр «Только текущая должность».
 */
export interface PostFilterParams {
  excludeJumpers?: unknown;
  filterByExpIndustry?: unknown;
  currentPositionOnly?: unknown;
}

export function needsPostFilter(params: PostFilterParams | null | undefined): boolean {
  if (!params) return false;
  return Boolean(
    params.excludeJumpers ||
    params.filterByExpIndustry ||
    params.currentPositionOnly,
  );
}
